import classNames from 'classnames';
import styles from './style.m.less';

const RIBBON_COLORS = {
    GREEN: styles.green,
    RED: styles.red,
    BLUE: styles.blue,
    GREY: styles.grey,
    ORANGE: styles.orange,
};

const SIDES = {
    LEFT: {
        container: styles.leftContainer,
        label: styles.leftLabel,
    },
    RIGHT: {
        container: styles.rightContainer,
        label: styles.rightLabel,
    },
};

type Props = {
    color?: keyof typeof RIBBON_COLORS;
    text: React.ReactNode;
    side?: keyof typeof SIDES;
    switchOnMobile?: boolean;
};

export default function Ribbon({ color = 'GREEN', text, side = 'LEFT', switchOnMobile = true }: Props) {
    const { container, label } = SIDES[side];

    return (
        <div className={classNames(container, { [styles.switchOnMobile]: switchOnMobile }, RIBBON_COLORS[color])}>
            <span className={classNames(label, { [styles.switchOnMobile]: switchOnMobile })}>{text}</span>
        </div>
    );
}
